import React from "react";
import { motion } from "framer-motion";

const StreamedTextFormatter = ({ text }) => {
  if (!text) return null;

  return text.split("\n").map((line, index) => (
    <motion.div
      key={index}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3, delay: index * 0.1 }}
    >
      {line}
      <br />
    </motion.div>
  ));
};

export default StreamedTextFormatter;
